import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk, createAction } = require("@reduxjs/toolkit");

//action
export const fetchMyBipList = createAsyncThunk(
  "fetchMyBipList",
  async ( {id,page,limit,filters} ) => {
   
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };

    const createdBy = filters?.createdBy?filters?.createdBy:"";
    const status = filters?.status?filters?.status:31;
    const keyword = filters?.keyword?filters?.keyword:"";
    
    const response = await axiosHttp.get(
      `bip/list?limit=${limit?limit:'1000000000000'}&page=${page?page:1}&createdBy=${createdBy}&status=${status}&keyword=${keyword}${id?'&goal='+id:''}`,
      config
    );

    return response.data.data;
  }
);

const initialState = () => ({
    isLoading: false,
    data: null,
    error: null,
});


const myBipListSlice = createSlice({
  name: "myBipList",
  initialState: initialState(),
  reducers: {
    resetBIPStore : state => initialState()
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMyBipList.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchMyBipList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchMyBipList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default myBipListSlice.reducer;